var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgE4Elevator(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 13v61h62V13H7zm58 21v36H11V17h54v17zm-14-5h6a5 5 0 015 5v12a2 2 0 01-4 0V34a1 1 0 00-1-1h-1v33a2 2 0 01-4 0V50h-2v16a2 2 0 01-4 0V33h-1a1 1 0 00-1 1v12a2 2 0 01-4 0V34a5 5 0 015-5h6zm0-10a4 4 0 012.59 7.06A4.001 4.001 0 1151 19zM45.93 8.87L39 2h14l-7.07 6.87zM37 8.94H23l7.06-6.87L37 8.94zM36 34v12a2 2 0 01-4 0V34a1 1 0 00-1-1h-1v33a2 2 0 01-4 0V50h-2v16a2 2 0 01-4 0V33h-1a1 1 0 00-1 1v12a2 2 0 01-4 0V34a5 5 0 015-5h12a5 5 0 015 5zm-14.06-8.37a4 4 0 116.12-5.153 4 4 0 01-6.12 5.153z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/E4_Elevator.e58ce09e.svg";
export { SvgE4Elevator as ReactComponent };